module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm3"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('p', {
    staticClass: "play"
  }, [_c('span', [_vm._v("Plays by John Guare")])]), _vm._v(" "), _c('p', {
    staticClass: "play1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bosoms and Neglect")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chaucer in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cop-Out")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Few Stout Individuals")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Four Baboons Adoring the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Free Man of Color")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("General of Hot Desire")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("His Girl Friday")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adaptation")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Home Fires")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("House of Blue Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lake Hollywood")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Landscape of the Body")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lydie Breeze:")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Part One: Women and Water")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Part Two: Bulfinch’s Mythology")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Part Three: The Sacredness of the Next Task")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Marco Polo Sings a Solo")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Moon Under Miami")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Muzeeka")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rich and Famous")])]), _vm._v(" "), _c('p', {
    staticClass: "play2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Six Degrees of Separation")])])])]), _c('a', {
    attrs: {
      "id": "pageii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd6787fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802195005_plays_by_john_guare.vue
// module id = 69
// module chunks = 0